import React, {useEffect, useState} from "react";
import SideNavLink from "./SideNavLink";
import setting from "../../icons/setting.svg";
import property from "../../icons/property.svg";
import support from "../../icons/Support.svg";
import logoutLogo from "../../icons/logout.svg";
import logo from "../../icons/logo.jpeg";
import home from "../../icons/home.svg";
import cross from "../../icons/cross.png";
import earnings from "../../icons/earnings.png";
import concierge from "../../icons/concierge.svg";
import ordersIcon from "../../icons/cart.png";
import {useDispatch, useSelector} from "react-redux";
import {NavLink, useLocation, useNavigate} from "react-router-dom";
import {
    hostEarningsReset,
    hostPendingEarningsReset,
    hostProfileReset,
    hostPropertiesReset,
    hostPropertyDetailsReset,
    logout,
    setBlurOff,
    setNavOff,
} from "../../store/slices/hostSlices";
import CsvExport from "./CsvExport";

const SideNav = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    const {hostInfo: hostLogin} = useSelector((state) => state.host);
    const {automationAllowed} = useSelector((state) => state.hostFlags);
    const {hostSideNav} = useSelector((state) => {
        return state;
    });
    const isOnBoarded = useSelector((state) => {
        return state.hostDetails.Info?.isOnBoarded;
    });

    const [laptopView, setLaptopView] = useState();

    const onClickCross = () => {
        dispatch(setNavOff());
        dispatch(setBlurOff());
    };

    const handleLogout = () => {
        if (window.confirm("Are you sure you want to log out?")) {
            dispatch(hostEarningsReset());
            dispatch(hostPropertiesReset());
            dispatch(hostPropertyDetailsReset());
            dispatch(hostPendingEarningsReset());
            dispatch(hostProfileReset());
            dispatch(logout());
            navigate("/login");
        }
    };

    const handleResize = () => {
        if (window.innerWidth > 1024) {
            setLaptopView(true);
        } else {
            setLaptopView(false);
            dispatch(setNavOff());
            dispatch(setBlurOff());
        }
    };

    useEffect(() => {
        handleResize();
    }, []);

    const isGuesty = hostLogin.propertyManagementSoftware?.find((software) => software === 'guesty');

    useEffect(() => {
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    
    return (
        <>
            {(hostSideNav || laptopView) && (
                <div
                    id="navLeft"
                    className="flex-col items-center w-[280px] bg-white border-r border-gray-200 shadow-sm laptop:sticky laptop:flex top-0 tablet:rounded-r-3xl tablet:z-20 tablet:absolute tablet:h-screen mobile:w-[85%] min-h-[650px]"
                >
                    {/* Close button for mobile/tablet */}
                    <div className="absolute top-4 right-4 laptop:hidden">
                        <button
                            onClick={onClickCross}
                            className="w-8 h-8 rounded-full bg-gray-100 hover:bg-red-50 hover:text-red-500 flex items-center justify-center transition-all duration-200"
                        >
                            <img
                                src={cross}
                                className="w-4 h-4 opacity-60"
                                alt="Close"
                            />
                        </button>
                    </div>

                    {/* Logo Section */}
                    <div className="flex justify-center items-center h-24 w-full px-6 mt-4">
                        <NavLink to="/host" className="w-full max-w-[140px]">
                            <img
                                className="w-full h-auto"
                                src={logo}
                                alt="Bellhopt Logo"
                                onClick={() => {
                                    dispatch(setNavOff());
                                    dispatch(setBlurOff());
                                }}
                            />
                        </NavLink>
                    </div>

                    {/* Mobile Only Add Property Button */}
                    <div className="laptop:hidden w-full px-6 mb-6">
                        <NavLink
                            to="/add-property"
                            className={`${!isOnBoarded && "pointer-events-none opacity-50"}`}
                        >
                            <button
                                className="w-full bg-gray-900 text-white font-bold px-4 py-4 rounded-xl transition-all duration-200 hover:bg-gray-800"
                                onClick={() => {
                                    dispatch(setNavOff());
                                    dispatch(setBlurOff());
                                }}
                            >
                                + Add Property
                            </button>
                        </NavLink>
                        <div className="mt-3">
                            <CsvExport className="w-full"/>
                        </div>
                    </div>

                    {/* Navigation Links */}
                    <div className="flex-grow w-full px-4">
                        <nav className="space-y-1">
                            {/* AFFILIATE VIEW */}
                            {hostLogin?.ota ? (
                                <>
                                    <SideNavLink
                                        icon={concierge}
                                        label={"Concierge"}
                                        link={"concierge"}
                                        active="activeNav"
                                    />
                                    <SideNavLink icon={support} label={"Support"} link={"support"}/>
                                </>
                            ) : (
                                // HOST VIEW
                                <>
                                    <SideNavLink
                                        icon={home}
                                        label={"Dashboard"}
                                        link={"host"}
                                        active="activeNav"
                                    />

                                    <SideNavLink
                                        icon={earnings}
                                        label={"Earnings"}
                                        link={`earnings`}
                                    />

                                    <SideNavLink
                                        icon={ordersIcon}
                                        label={"Orders"}
                                        link={`order-list`}
                                    />

                                    <SideNavLink
                                        icon={property}
                                        label={"Properties"}
                                        link={`properties`}
                                    />

                                    <SideNavLink
                                        icon={property}
                                        label={"Integrations"}
                                        link={"integrations"}
                                    />

                                    <SideNavLink
                                        icon={concierge}
                                        label={"Concierge"}
                                        link={"concierge-subscription"}
                                    />

                                    {/* <SideNavLink
                                        icon={concierge}
                                        label={"Services"}
                                        link={"services"}
                                    /> */}

                                    <SideNavLink
                                        icon={setting}
                                        label={"Profile Settings"}
                                        link={`settings/${hostLogin._id}`}
                                    />

                                    <SideNavLink icon={support} label={"Support"} link={"support"}/>

                                    {
                                        isGuesty === 'guesty' && (
                                            <SideNavLink
                                                icon={property}
                                                label={"Sync Guesty Properties"}
                                                link={`sync-guesty-properties`}
                                            />
                                        )
                                    }

                                </>
                            )}
                        </nav>
                    </div>

                    {/* Logout Button */}
                    <div className="w-full px-4 pb-6">
                        <div className="border-t border-gray-200 pt-4">
                            <button
                                onClick={handleLogout}
                                className="w-full flex items-center justify-center gap-3 px-4 py-3 text-gray-400 hover:text-red-500 hover:bg-red-50 rounded-xl transition-all duration-200 group"
                            >
                                <img
                                    src={logoutLogo}
                                    alt="Logout"
                                    className="w-5 h-5 opacity-50 group-hover:opacity-80 transition-all"
                                />
                                <span className="font-medium">Logout</span>
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default SideNav;
